// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"30243079","239":"d8e72614","732":"8ffc54e0"}[chunkId] + ".chunk.js";
};